<google-map
  height="100%"
  width="100%"
  [center]="center"
  [zoom]="zoom"
  (mapClick)="onMapClick($event)">

  @for (point of points; track point.id) {
    @if (isValidPoint(point)) {
    <map-marker
      #marker="mapMarker"
      [position]="pointPosition(point)"
      [title]="formatAddress(point)"
      (mapClick)="openInfo(marker, point)">
    </map-marker>
    }
  }

  <map-info-window>
    @if (activePoint) {
      <strong>{{ formatAddress(activePoint) }}</strong>
    }
  </map-info-window>
</google-map>
